export default {
	letters: /^[a-zA-Z]*$/gm,
	lettersAndWhiteSpaces: /^[a-zA-Z ]*$/gm,
	digits: /^\+?[0-9 () ]*$/gm,
}
